module.exports = __webpack_public_path__ + "static/media/CTLI_5-444w.780bdd20.png";